const { fillWithDomElements, trackGtm, trackGtm4 } = require('util/functions');

const CLASS_CTA = 'cta';
const CLASS_ARROW_LINK = 'arrow-link';
const CLASS_PICTURE_LINK = 'article-intro--picture';
const CLASS_TITLE = 'article-intro--title';

const selectors = {
	cta: CLASS_CTA,
	arrowLink: CLASS_ARROW_LINK,
	picture: CLASS_PICTURE_LINK,
	title: CLASS_TITLE,
};

module.exports = {
	init() {
		fillWithDomElements(this, selectors);

		this.initEvents();
	},
	initEvents() {
		if (this.cta) {
			this.cta.addEventListener('click', event => {
				this.gtmTracking(event);
			});
		}

		if (this.arrowLink) {
			this.arrowLink.addEventListener('click', event => {
				this.gtmTracking(event);
			});
		}

		if (this.picture) {
			this.picture.addEventListener('click', event => {
				this.gtmTracking(event);
			});
		}
	},
	gtmTracking(event) {
		const dataSelector = this.root.getAttribute('data-parent');
		trackGtm({
			eventCategory: 'cta',
			eventAction: 'button',
			eventLabel: `${this.title.textContent} | ${event.target.textContent} | ${event.target.href}`,
		});
		trackGtm4({
			event: 'GA4_event_c_cta',
			widget_name: dataSelector,
			widget_title: this.title.textContent,
			link_text:
				event.target.tagName == 'IMG'
					? `Image alt text: ${event.target.alt}`
					: event.target.textContent,
			link_url:
				event.target.tagName == 'IMG'
					? event.target.parentNode.href
					: event.target.href,
			button_type: '',
		});
	},
};
